import PropTypes from 'prop-types';
import {  useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import { gridSpacing } from '../../../store/constant';


const SingleLineChart = ({ isLoading, categories, title, decimal, series, lineWidth, lineDash }) => {
    const theme = useTheme();
    const { primary } = theme.palette.text;
    const grey200 = "#eeeeee";
    const grey500 = "#9e9e9e";
    const primary200 = "#90caf9";
    const primaryDark = "#1e88e5";
    const secondaryMain = "#673ab7";
    const secondaryLight = "#ede7f6";

    const lineChartData = {
        height: 370,
        width: 500,
        options: {
            chart: {
                type: 'line',
                id: 'line-chart',
                toolbar: {
                    show: false
                },
            },
            xaxis: {
                type: 'category',
                categories: categories
            },
            yaxis: [
              {
                labels: {
                  formatter: function(val) {
                    return val.toFixed(decimal);
                  }
                }
              }
            ],
            stroke: {
                width: lineWidth,
                curve: 'smooth',
                dashArray: lineDash,
            },
            title: {
                text: title,
                align: 'left'
            },
            colors: ['#60ced2','#60c7fc','#3d85c6','#0b5394']
        },
        series: series,
    };

    useEffect(() => {
        const newChartData = {...lineChartData.series,};
            if (categories !== null){
                      if (!isLoading && categories !== null && categories.length > 0) {
                ApexCharts.exec(`line-chart`, 'updateOptions', newChartData);
            }
        }

    }, [ primary200, primaryDark, secondaryMain, secondaryLight, primary, grey200, isLoading, grey500, lineChartData.series, categories]);

    return (
        <>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Chart {...lineChartData} />
                        </Grid>
                    </Grid>
        </>
    );
};

SingleLineChart.propTypes = {
    isLoading: PropTypes.bool
};

SingleLineChart.defaultProps = {
  lineWidth: [7, 3, 3],
  lineDash: [0, 10, 10],
};


export default SingleLineChart;
